import { compose, includes, propOr } from 'ramda';

export const extraMessageErrorSaveDocument = (context) => {
  const creatorIsBroker = compose(includes('BROKER'), propOr([], 'creatorUserRoles'))(context);

  const BROKER_MULESOFT_ERROR_MESSAGE = `Suite à une indisponibilité technique, les documents n’ont pas pu être
        enregistrés dans notre système d’information. Merci de nous les faire parvenir par mail : <a className="font-bold"
            href="mailto:courtage@pavillon-prevoyance.fr">courtage@pavillon-prevoyance.fr</a>.
        Vous pouvez néanmoins poursuivre votre adhésion.`;

  const SAVE_DOCUMENTS_ERROR_MESSAGE =
    'Suite à une indisponibilité technique, les documents n’ont pas pu être enregistrés dans Salesforce. Merci de les télécharger directement dans Salesforce à l’emplacement adéquat. Vous pouvez néanmoins poursuivre votre adhésion.';

  return creatorIsBroker ? BROKER_MULESOFT_ERROR_MESSAGE : SAVE_DOCUMENTS_ERROR_MESSAGE;
};
